/**
 * [fnProductDocumentDownload handles the product document download functions]
 * @param  {[type]} i        [description]
 * @param  {[type]} oSection [description]
 * @return {[type]}          [description]
 */
function fnDataCaptureForm(i, oSection) {
    var oElement = $(oSection);

    $('a.proceed', oElement).on("click", function() {
        oElement.addClass('processing');


        //  Fields
        var oNameField = $('input[name="name"]', oElement).closest('.input-field'),
            oCompanyField = $('input[name="company"]', oElement).closest('.input-field'),
            oJobTitleField = $('input[name="jobtitle"]', oElement).closest('.input-field'),
            oEmailField = $('input[name="email"]', oElement).closest('.input-field'),
            oFormId = $('input[name="form_id"]', oElement),
            oOptIn = $('input[name="optin"]', oElement),
            oReCaptcha = $('input[name="g-recaptcha-response"]', oElement),




            //  Other elements
            oFormInputs = $('.form-inputs', oElement),
            oHtmlResponse = $('.file-area', oElement),
            iFormId = oFormId.val(),
            sReCaptcha = oReCaptcha.val(),
            sNameField = $('input', oNameField).val(),
            sCompanyField = $('input', oCompanyField).val(),
            sJobTitleField = $('input', oJobTitleField).val(),
            sEmailField = $('input', oEmailField).val(),
            sOptInField = oOptIn.val();




        //  Reset
        oNameField.removeClass('active error');
        oCompanyField.removeClass('active error');
        oJobTitleField.removeClass('active error');
        oEmailField.removeClass('active error');

        //  First name
        if (sNameField.length >= 2) {
            oNameField.addClass('active');
        } else {
            oNameField.addClass('error');
        }
        //  Company field
        if (sCompanyField.length >= 2) {
            oCompanyField.addClass('active');
        } else {
            oCompanyField.addClass('error');
        }
        //  Job title
        if (sJobTitleField.length >= 2) {
            oJobTitleField.addClass('active');
        } else {
            oJobTitleField.addClass('error');
        }

        //  Email
        if (sEmailField.length >= 2) {
            oEmailField.addClass('active');
        } else {
            oEmailField.addClass('error');
        }



        //  Ensure fields have data before submitting
        if ( sEmailField.length >= 2 && validateEmail( sEmailField ) ) {

            if ( sNameField.length >= 2 && sCompanyField.length >= 2 && sJobTitleField.length >= 2 ) {

                //  Set data
                var aPushData = {
                    name: sNameField,
                    company: sCompanyField,
                    jobtitle: sJobTitleField,
                    email: sEmailField,
                    optin: sOptInField,
                    form_id: iFormId,
                    token: sReCaptcha
                };
                console.log(aPushData);

                var oData = new Object;

                oData.action = "send_download_request";
                oData.push_data = aPushData;
                oEmailField.addClass('active');

                $.ajax({
                    'data': oData,
                    'dataType': 'json',
                    'type': 'POST',
                    'url': '/wp-admin/admin-ajax.php',
                    'success': function(oResponse) {
                        if(oResponse.success){
                            oHtmlResponse.html(oResponse.html);
                            oElement.removeClass('processing');
                            oFormInputs.slideUp();
                        }else{
                            oElement.removeClass('processing');
                            oEmailField.addClass('error');
                        }



                    }
                });

            } else {
                oElement.removeClass('processing');
            }

        } else {
            oElement.removeClass('processing');
            oEmailField.addClass('error');
        }

    });

}


/*
  Helpers
 */
function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
